export const constants = {
    apiUri: window.globalConfig.apiUri,
    clientId: window.globalConfig.client_id,
    maxQuantity: window.globalConfig.maxQuantity,
    minQuantity: window.globalConfig.minQuantity,
}